import { useCallback } from 'react';
import { Button, Col, Icon, Row, Tooltip } from 'ui';
import { useCalendarSettings } from '../../../storages';
import type { CalendarSearchParamsOptions, CalendarSetting } from '../../../types';
import { useGetShiftedDate, useGetTooltipTitle } from './hooks';

export type ButtonDirection = 'next' | 'previous' | 'today';

type P = {
  date: CalendarSetting['date'];
  updateSearchParams: CalendarSearchParamsOptions['updateSearchParams'];
};

const DateNavigator = ({ date, updateSearchParams }: P) => {
  const [{ mode }] = useCalendarSettings();
  const getTooltipTitle = useGetTooltipTitle();
  const getShiftedDate = useGetShiftedDate();

  const handleDate = useCallback(
    (direction: ButtonDirection) => {
      updateSearchParams({ date: getShiftedDate({ date, direction, mode }) });
    },
    [updateSearchParams, getShiftedDate, date, mode],
  );

  return (
    <Row gutter="xxs">
      <Col>
        <Tooltip title={getTooltipTitle({ date, direction: 'previous', mode })}>
          <Button
            icon={<Icon icon="left-line" />}
            onClick={() => {
              handleDate('previous');
            }}
            size="middle"
          />
        </Tooltip>
      </Col>
      <Col>
        <Tooltip title={getTooltipTitle({ date, direction: 'today', mode })}>
          <Button
            onClick={() => {
              handleDate('today');
            }}
            size="middle"
          >
            Today
          </Button>
        </Tooltip>
      </Col>
      <Col>
        <Tooltip title={getTooltipTitle({ date, direction: 'next', mode })}>
          <Button
            icon={<Icon icon="right-line" />}
            onClick={() => {
              handleDate('next');
            }}
            size="middle"
          />
        </Tooltip>
      </Col>
    </Row>
  );
};

export default DateNavigator;
